// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: var(--md-sys-bg-landing);
    color: var(--md-sys-color-on-surface-variant);;
}

strong {
    font-family: var(--md-sys-typescale-display-medium-font-family-name);
}

.text-description > * {
    font-family: 'ProductSans-Medium', Arial, Helvetica, sans-serif;
}

.landing-bg {
    position: relative;
    width: 100%;
    height: 100vh;
    height: 100dvh;
    padding: 15rem 0;
    overflow: hidden;
}

hr.divider {
    max-width: 3.25rem;
    border-width: 0.2rem;
    border-color: #f4623a;
    opacity: 1;
}

hr.divider-light {
    border-color: #fff;
}

.me {
    display: flex;
    justify-content: center;
    font-size: clamp(2rem, 6vw, 5rem) !important;
    font-weight: bold;
    color: #219F83;
}

.letter, .space {
    display: inline-block;
    opacity: 0;
    transform: translateY(20px);
    animation: fadeInUp 0.8s ease-out forwards;
    mix-blend-mode: difference;
}

/* Délai d'apparition des lettres */
.letter:nth-child(1) {
    animation-delay: 0s;
}

.letter:nth-child(2) {
    animation-delay: 0.1s;
}

.letter:nth-child(3) {
    animation-delay: 0.2s;
}

.letter:nth-child(4) {
    animation-delay: 0.3s;
}

.letter:nth-child(5) {
    animation-delay: 0.4s;
}

.space {
    width: clamp(10px, 2vw, 20px);
    display: inline-block;
}

.letter:nth-child(7) {
    animation-delay: 0.5s;
}

.letter:nth-child(8) {
    animation-delay: 0.6s;
}

.letter:nth-child(9) {
    animation-delay: 0.7s;
}

.letter:nth-child(10) {
    animation-delay: 0.8s;
}

.letter:nth-child(11) {
    animation-delay: 0.9s;
}

.letter:nth-child(12) {
    animation-delay: 1s;
}

/* Animation du SVG (Soulignement) */
.underline-svg {
    margin-top: 10px;
}

.underline-path {
    stroke-dasharray: 250;
    stroke-dashoffset: 250;
    animation: drawLine 1.5s ease-out 1.2s forwards;
}

/* Animation du Job Title */
.job-title {
    margin-top: 20px;
    text-align: center;
    opacity: 0;
    transform: translateY(20px);
    animation: fadeInUp 1s ease-out 1.5s forwards;
}

/* Animation du Bouton */
.btn-landing {
    opacity: 0;
    transform: scale(0.8);
    animation: fadeInScale 0.8s ease-out 2s forwards;
    transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

/* Effet au survol */
.btn-landing:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}


@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeInScale {
    from {
        opacity: 0;
        transform: scale(0.8);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes drawLine {
    from {
        stroke-dashoffset: 250;
    }
    to {
        stroke-dashoffset: 0;
    }
}


section {
    padding-left: 10px;
    padding-top: 3rem;
    padding-bottom: 3rem;
}

footer {
    background-color: var(--md-sys-color-surface);
    color: var(--md-sys-color-on-surface-variant);
    font-weight: 400;
}

.copyright, .copyright > * {
    font-family: var(--md-sys-typescale-footer-copyright-family-name);
}

footer a {
    color: var(--md-sys-color-on-surface-variant);
}

.sharethis-inline-share-buttons {
    margin-top: 10px;
}

.st-total {
    margin-right: 20px !important;
    color: var(--md-sys-color-on-surface-variant) !important;
}

.contact-section {
    background-color: var(--md-sys-color-surface);
    color: var(--md-sys-color-on-surface-variant);
}

.projects-section {
    padding-top: 3rem;
    padding-bottom: 3rem;
    background-color: var(--md-sys-color-surface);
    color: var(--md-sys-color-surface);
}

.circle, .star {
    transform: scale(0);
    transition: transform 0.9s ease-out;
    will-change: transform; /* Optimisation pour les animations */
    position: absolute;
    z-index: -1;
}

.circle {
    /*height: 500px;*/
    /*width: 500px;*/
    border-radius: 50%;
    transform: translate(-50%, -50%);
}

.star {
    overflow: hidden;
    /*width: 350px;*/
    /*height: 350px;*/
    height: 40vw;
    width: 40vw;
    top: 85%;
    left: 25%;
    transform: translate(-50%, -50%);
}

.circle-green {
    background-color: var(--md-sys-color-landing-circle1);
    top: 10%;
    left: 25%;
    /*height: 350px;*/
    /*width: 350px;*/
    height: 25vw;
    width: 25vw;
}

.circle-blue {
    background-color: var(--md-sys-color-landing-circle2);
    top: 3%;
    left: 45%;
    /*height: 450px;*/
    /*width: 450px;*/
    height: 30vw;
    width: 30vw;
}

.circle-red {
    background-color: var(--md-sys-color-landing-circle3);
    top: 50%;
    left: 80%;
    height: 35vw;
    width: 35vw;
}

.brand {
    font-weight: 600;
}

.card {
    /*background-color: var(--md-sys-color-surface);*/
    border-radius: 8px;
    box-shadow: var(--md-sys-color-shadow);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: transparent;
    border: none;
    border-radius: 20px;
    box-shadow: 0px 1px 2px 0px rgb(0 0 0 / 30%), 0px 2px 6px 2px rgb(0 0 0 / 15%);
}

.card-header {
    padding: 16px;
}

.card-title {
    color: var(--md-sys-color-on-surface);
    font-size: 20px;
    font-weight: 600;
    margin: 0;
}

.card-content {
    padding: 16px;
}

.card-text {
    color: var(--md-sys-color-on-surface);
    font-size: 14px;
    margin: 0;
}

.card-img {
    border-radius: 20px;
}

.img-project {
    max-width: 170px;
    max-height: 150px;
    min-height: 150px;
    padding: 2px;
    margin: 3px;
    border-radius: 20px;
    background-color: var(--md-sys-color-tertiary);
}

.badge-project {
    background-color: var(--md-sys-color-secondary-container);
    color: var(--md-sys-color-secondary);
    font-family: var(--md-sys-typescale-display-small-font-family-name);
}

.badge-date {
    background-color: var(--md-sys-color-tertiary-container);
    color: var(--md-sys-color-tertiary);
    font-family: var(--md-sys-typescale-display-small-font-family-name);
}

.collapsible {
    margin-bottom: 10px;
    border-radius: 4px;
}

.collapsible-header {
    cursor: pointer;
    background-color: var(--md-sys-color-surface-tint);
    color: var(--md-sys-color-surface);
    padding: 12px;
    border-radius: 20px 20px 0 0;
    margin-top: 10px;
}

.collapsible-header.collapsed {
    border-radius: 20px 20px 20px 20px;
    transition-duration: 1s;
}

.collapsible-header:hover {
    background-color: var(--md-sys-color-surface-tint);
}

.collapsible-header i.material-icons {
    font-size: 24px;
}

.collapsible-body {
    padding: 12px;
    background-color: var(--md-sys-color-surface);
    color: var(--md-sys-color-on-surface);
    border: none;
    border-radius: 0 0 20px 20px;
    margin-bottom: 10px;
}

#g-recaptcha-response {
    display: block !important;
    position: absolute;
    margin: -50px 0 0 0 !important;
    z-index: -999999;
    opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./src/css/styles.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,6CAA6C;AACjD;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,+DAA+D;AACnE;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,4CAA4C;IAC5C,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,2BAA2B;IAC3B,0CAA0C;IAC1C,0BAA0B;AAC9B;;AAEA,mCAAmC;AACnC;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oCAAoC;AACpC;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,+CAA+C;AACnD;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA,wBAAwB;AACxB;IACI,UAAU;IACV,qBAAqB;IACrB,gDAAgD;IAChD,mEAAmE;AACvE;;AAEA,oBAAoB;AACpB;IACI,sBAAsB;IACtB,yCAAyC;AAC7C;;;AAGA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,oBAAoB;IACxB;AACJ;;;AAGA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,6CAA6C;IAC7C,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA;IACI,iEAAiE;AACrE;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,wDAAwD;AAC5D;;AAEA;IACI,6CAA6C;IAC7C,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,6CAA6C;IAC7C,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,sBAAsB,EAAE,qCAAqC;IAC7D,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,qDAAqD;IACrD,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qDAAqD;IACrD,OAAO;IACP,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qDAAqD;IACrD,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iDAAiD;IACjD,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;IACZ,mBAAmB;IACnB,8EAA8E;AAClF;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,yDAAyD;IACzD,oCAAoC;IACpC,mEAAmE;AACvE;;AAEA;IACI,wDAAwD;IACxD,mCAAmC;IACnC,mEAAmE;AACvE;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kDAAkD;IAClD,kCAAkC;IAClC,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,6CAA6C;IAC7C,qCAAqC;IACrC,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;IAChB,UAAU;AACd","sourcesContent":["body {\r\n    background-color: var(--md-sys-bg-landing);\r\n    color: var(--md-sys-color-on-surface-variant);;\r\n}\r\n\r\nstrong {\r\n    font-family: var(--md-sys-typescale-display-medium-font-family-name);\r\n}\r\n\r\n.text-description > * {\r\n    font-family: 'ProductSans-Medium', Arial, Helvetica, sans-serif;\r\n}\r\n\r\n.landing-bg {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100vh;\r\n    height: 100dvh;\r\n    padding: 15rem 0;\r\n    overflow: hidden;\r\n}\r\n\r\nhr.divider {\r\n    max-width: 3.25rem;\r\n    border-width: 0.2rem;\r\n    border-color: #f4623a;\r\n    opacity: 1;\r\n}\r\n\r\nhr.divider-light {\r\n    border-color: #fff;\r\n}\r\n\r\n.me {\r\n    display: flex;\r\n    justify-content: center;\r\n    font-size: clamp(2rem, 6vw, 5rem) !important;\r\n    font-weight: bold;\r\n    color: #219F83;\r\n}\r\n\r\n.letter, .space {\r\n    display: inline-block;\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n    animation: fadeInUp 0.8s ease-out forwards;\r\n    mix-blend-mode: difference;\r\n}\r\n\r\n/* Délai d'apparition des lettres */\r\n.letter:nth-child(1) {\r\n    animation-delay: 0s;\r\n}\r\n\r\n.letter:nth-child(2) {\r\n    animation-delay: 0.1s;\r\n}\r\n\r\n.letter:nth-child(3) {\r\n    animation-delay: 0.2s;\r\n}\r\n\r\n.letter:nth-child(4) {\r\n    animation-delay: 0.3s;\r\n}\r\n\r\n.letter:nth-child(5) {\r\n    animation-delay: 0.4s;\r\n}\r\n\r\n.space {\r\n    width: clamp(10px, 2vw, 20px);\r\n    display: inline-block;\r\n}\r\n\r\n.letter:nth-child(7) {\r\n    animation-delay: 0.5s;\r\n}\r\n\r\n.letter:nth-child(8) {\r\n    animation-delay: 0.6s;\r\n}\r\n\r\n.letter:nth-child(9) {\r\n    animation-delay: 0.7s;\r\n}\r\n\r\n.letter:nth-child(10) {\r\n    animation-delay: 0.8s;\r\n}\r\n\r\n.letter:nth-child(11) {\r\n    animation-delay: 0.9s;\r\n}\r\n\r\n.letter:nth-child(12) {\r\n    animation-delay: 1s;\r\n}\r\n\r\n/* Animation du SVG (Soulignement) */\r\n.underline-svg {\r\n    margin-top: 10px;\r\n}\r\n\r\n.underline-path {\r\n    stroke-dasharray: 250;\r\n    stroke-dashoffset: 250;\r\n    animation: drawLine 1.5s ease-out 1.2s forwards;\r\n}\r\n\r\n/* Animation du Job Title */\r\n.job-title {\r\n    margin-top: 20px;\r\n    text-align: center;\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n    animation: fadeInUp 1s ease-out 1.5s forwards;\r\n}\r\n\r\n/* Animation du Bouton */\r\n.btn-landing {\r\n    opacity: 0;\r\n    transform: scale(0.8);\r\n    animation: fadeInScale 0.8s ease-out 2s forwards;\r\n    transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\r\n}\r\n\r\n/* Effet au survol */\r\n.btn-landing:hover {\r\n    transform: scale(1.05);\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n\r\n@keyframes fadeInUp {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(20px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n@keyframes fadeInScale {\r\n    from {\r\n        opacity: 0;\r\n        transform: scale(0.8);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n@keyframes drawLine {\r\n    from {\r\n        stroke-dashoffset: 250;\r\n    }\r\n    to {\r\n        stroke-dashoffset: 0;\r\n    }\r\n}\r\n\r\n\r\nsection {\r\n    padding-left: 10px;\r\n    padding-top: 3rem;\r\n    padding-bottom: 3rem;\r\n}\r\n\r\nfooter {\r\n    background-color: var(--md-sys-color-surface);\r\n    color: var(--md-sys-color-on-surface-variant);\r\n    font-weight: 400;\r\n}\r\n\r\n.copyright, .copyright > * {\r\n    font-family: var(--md-sys-typescale-footer-copyright-family-name);\r\n}\r\n\r\nfooter a {\r\n    color: var(--md-sys-color-on-surface-variant);\r\n}\r\n\r\n.sharethis-inline-share-buttons {\r\n    margin-top: 10px;\r\n}\r\n\r\n.st-total {\r\n    margin-right: 20px !important;\r\n    color: var(--md-sys-color-on-surface-variant) !important;\r\n}\r\n\r\n.contact-section {\r\n    background-color: var(--md-sys-color-surface);\r\n    color: var(--md-sys-color-on-surface-variant);\r\n}\r\n\r\n.projects-section {\r\n    padding-top: 3rem;\r\n    padding-bottom: 3rem;\r\n    background-color: var(--md-sys-color-surface);\r\n    color: var(--md-sys-color-surface);\r\n}\r\n\r\n.circle, .star {\r\n    transform: scale(0);\r\n    transition: transform 0.9s ease-out;\r\n    will-change: transform; /* Optimisation pour les animations */\r\n    position: absolute;\r\n    z-index: -1;\r\n}\r\n\r\n.circle {\r\n    /*height: 500px;*/\r\n    /*width: 500px;*/\r\n    border-radius: 50%;\r\n    transform: translate(-50%, -50%);\r\n}\r\n\r\n.star {\r\n    overflow: hidden;\r\n    /*width: 350px;*/\r\n    /*height: 350px;*/\r\n    height: 40vw;\r\n    width: 40vw;\r\n    top: 85%;\r\n    left: 25%;\r\n    transform: translate(-50%, -50%);\r\n}\r\n\r\n.circle-green {\r\n    background-color: var(--md-sys-color-landing-circle1);\r\n    top: 10%;\r\n    left: 25%;\r\n    /*height: 350px;*/\r\n    /*width: 350px;*/\r\n    height: 25vw;\r\n    width: 25vw;\r\n}\r\n\r\n.circle-blue {\r\n    background-color: var(--md-sys-color-landing-circle2);\r\n    top: 3%;\r\n    left: 45%;\r\n    /*height: 450px;*/\r\n    /*width: 450px;*/\r\n    height: 30vw;\r\n    width: 30vw;\r\n}\r\n\r\n.circle-red {\r\n    background-color: var(--md-sys-color-landing-circle3);\r\n    top: 50%;\r\n    left: 80%;\r\n    height: 35vw;\r\n    width: 35vw;\r\n}\r\n\r\n.brand {\r\n    font-weight: 600;\r\n}\r\n\r\n.card {\r\n    /*background-color: var(--md-sys-color-surface);*/\r\n    border-radius: 8px;\r\n    box-shadow: var(--md-sys-color-shadow);\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n    background-color: transparent;\r\n    border: none;\r\n    border-radius: 20px;\r\n    box-shadow: 0px 1px 2px 0px rgb(0 0 0 / 30%), 0px 2px 6px 2px rgb(0 0 0 / 15%);\r\n}\r\n\r\n.card-header {\r\n    padding: 16px;\r\n}\r\n\r\n.card-title {\r\n    color: var(--md-sys-color-on-surface);\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    margin: 0;\r\n}\r\n\r\n.card-content {\r\n    padding: 16px;\r\n}\r\n\r\n.card-text {\r\n    color: var(--md-sys-color-on-surface);\r\n    font-size: 14px;\r\n    margin: 0;\r\n}\r\n\r\n.card-img {\r\n    border-radius: 20px;\r\n}\r\n\r\n.img-project {\r\n    max-width: 170px;\r\n    max-height: 150px;\r\n    min-height: 150px;\r\n    padding: 2px;\r\n    margin: 3px;\r\n    border-radius: 20px;\r\n    background-color: var(--md-sys-color-tertiary);\r\n}\r\n\r\n.badge-project {\r\n    background-color: var(--md-sys-color-secondary-container);\r\n    color: var(--md-sys-color-secondary);\r\n    font-family: var(--md-sys-typescale-display-small-font-family-name);\r\n}\r\n\r\n.badge-date {\r\n    background-color: var(--md-sys-color-tertiary-container);\r\n    color: var(--md-sys-color-tertiary);\r\n    font-family: var(--md-sys-typescale-display-small-font-family-name);\r\n}\r\n\r\n.collapsible {\r\n    margin-bottom: 10px;\r\n    border-radius: 4px;\r\n}\r\n\r\n.collapsible-header {\r\n    cursor: pointer;\r\n    background-color: var(--md-sys-color-surface-tint);\r\n    color: var(--md-sys-color-surface);\r\n    padding: 12px;\r\n    border-radius: 20px 20px 0 0;\r\n    margin-top: 10px;\r\n}\r\n\r\n.collapsible-header.collapsed {\r\n    border-radius: 20px 20px 20px 20px;\r\n    transition-duration: 1s;\r\n}\r\n\r\n.collapsible-header:hover {\r\n    background-color: var(--md-sys-color-surface-tint);\r\n}\r\n\r\n.collapsible-header i.material-icons {\r\n    font-size: 24px;\r\n}\r\n\r\n.collapsible-body {\r\n    padding: 12px;\r\n    background-color: var(--md-sys-color-surface);\r\n    color: var(--md-sys-color-on-surface);\r\n    border: none;\r\n    border-radius: 0 0 20px 20px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n#g-recaptcha-response {\r\n    display: block !important;\r\n    position: absolute;\r\n    margin: -50px 0 0 0 !important;\r\n    z-index: -999999;\r\n    opacity: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
